import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import { Col } from "reactstrap";
import Counter from "../../Tool/Counter/Counter";
import Library from "../../Modal/Library/Library";
import CloneICON from "../../../assets/images/clone.svg";
import Popup from "../../Modal/Popup";
import AddPlus from "../../../assets/images/add_file.svg";
import AddPlusActive from "../../../assets/images/add_file_active.svg";
import cloneDeep from "lodash.clonedeep";
import * as UTILS from "../../../utils/Utils";
import "./File.scss";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import RangeInputSlider from "../../Tool/RangeSlider";
import noImage from "../../../assets/images/noimage.png";

class File extends Component {
  constructor(props) {
    super(props);
    this.widthInputVideo = React.createRef();
    this.state = {
      clickedImageID: null,
      imageLibrary: false,
      id: null,
      editID: null,
      thumb: null,
      thumbID: null,
      files: this.props.files,
      maxWidthRange: null,
      resizeWidth: false,
    };
  }
  componentDidMount = () => {
    this.setState({
      maxWidthRange: this.widthInputVideo.current.clientWidth,
    });
    this.setState({
      thumb: this.props.thumb,
      thumbID: this.props.thumbID,
    });
  };
  componentWillUnmount = () => {};

  setIdForEditHandler = (editID) => {
    this.setState({
      id: editID,
    });
  };

  unitWidthValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
        item.style.maxWidth = e.target.value == "%" ? "100" : "400";
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
        colItem.style.maxWidth = e.target.value == "%" ? "100" : "400";
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
        colItemNested.style.maxWidth = e.target.value == "%" ? "100" : "400";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  changeFileOpacity = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.opacity = selectedValue;
      },
      (colItem) => {
        colItem.style.opacity = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style.opacity = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  widthToggle = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.checked == true ? "" : "400";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
        item.style.fileWidthUnit = e.target.checked == false ? "px" : "%";
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
        colItem.style.fileWidthUnit = e.target.checked == false ? "px" : "%";
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
        colItemNested.style.fileWidthUnit =
          e.target.checked == false ? "px" : "%";
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  changeFileAlign = (e) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.float = selectedValue;
      },
      (colItem) => {
        colItem.style.float = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style.float = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  chooseThumb = (fileID) => {
    const layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.thumb = fileID.file_thumb;
        item.thumbID = fileID.file_id;
      },
      (colItem) => {
        colItem.thumb = fileID.file_thumb;
        colItem.thumbID = fileID.file_id;
      },
      (colItemNested) => {
        colItemNested.thumb = fileID.file_thumb;
        colItemNested.thumbID = fileID.file_id;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  deleteFile = () => {
    const layout = cloneDeep(this.props.layout);
    let fileSelected = {};
    layout.map((item, index) => {
      if (
        item.id == this.props.ID &&
        (item.data !== `Row` || item.data !== `Accordion`)
      ) {
        fileSelected = item;
      }
      if (
        item.id !== this.props.ID &&
        (item.data == `Row` || item.data == "Accordion")
      ) {
        Object.keys(item.columns).map((key, index) => {
          return item.columns[key].map((secondNest, secondIndex) => {
            if (secondNest.id == this.props.ID && secondNest.data !== `Row`) {
              fileSelected = secondNest;
            }
            if (secondNest.id !== this.props.ID && secondNest.data == `Row`) {
              Object.keys(secondNest.columns).map((thirdkey, index) => {
                return secondNest.columns[thirdkey].map(
                  (thirdItem, thirdIndex) => {
                    if (
                      thirdItem.id == this.props.ID &&
                      thirdItem.data !== `Row`
                    ) {
                      fileSelected = thirdItem;
                    }
                  }
                );
              });
            }
          });
        });
      }
    });
    //
    fileSelected.files = [];
    var newLayout =
      fileSelected &&
      UTILS.UpdateLayout(
        layout,
        this.props.ID,
        (item) => {
          item = fileSelected;
          item.thumb = null;
          item.thumbID = null;
        },
        (colItem) => {
          colItem = fileSelected;
          colItem.thumb = null;
          colItem.thumbID = null;
        },
        (colItemNested) => {
          colItemNested = fileSelected;
          colItemNested.thumb = null;
          colItemNested.thumbID = null;
        }
      );

    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  // Height CONTROLS
  unitValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  rangeWidthSlider = (width) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      width !== "" && width !== "0" && width !== "00"
        ? width.replace(/\b0+/g, "")
        : "0";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style.maxWidth = selectedValue;
      },
      (colItem) => {
        colItem.style.maxWidth = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style.maxWidth = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  addFileLabel = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(this.props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  render() {
    return (
      <div className="file-wrapper" ref={this.widthInputVideo}>
        {!this.props.element.dataModule && (
          <div className="actionControl">
            <span
              onClick={() => {
                this.setState({ editID: this.props.ID });
              }}
              className="image-setting"
            >
              File Settings
            </span>
            <button className="clone-item" onClick={() => { this.props.cloneElement(this.props.element.id) }}>
              <img src={CloneICON} />
            </button>
            <span className="delete-item" onClick={() => { this.props.deleteElement(this.props.element.id) }}>
              <i className="far fa-trash-alt" />
            </span>
          </div>
        )}{" "}
        {this.props.thumb !== null ? (
          <div className="fileWrapper">
            <img
              onError={(e) => {
                e.target.src = noImage;
              }}
              style={{
                maxWidth:
                  this.props.width !== ""
                    ? this.props.width +
                      (this.props.fileWidthUnit
                        ? this.props.fileWidthUnit
                        : "px")
                    : "100%",
                opacity: this.props.opacity,
                float: this.props.float,
                borderRadius: this.props.radius + "px",
                marginTop:
                  this.props.marginTop +
                  (this.props.fileMarginUnit
                    ? this.props.fileMarginUnit
                    : "px"),
                marginBottom:
                  this.props.marginBottom +
                  (this.props.fileMarginUnit
                    ? this.props.fileMarginUnit
                    : "px"),
                width: "100%",
              }}
              id="main"
              src={this.props.thumb ? this.props.thumb : null}
            />
          </div>
        ) : (
          <div
            className={
              "addImageHolder" + (this.props.thumb ? " " : " ")
            }
          >
            <button onClick={() => this.setIdForEditHandler(this.props.ID)}>
              <img className="normal" src={AddPlus} />
              <img className="active" src={AddPlusActive} />
            </button>
            <span>Add File</span>
          </div>
        )}
        {this.state.editID ? (
          <Popup
            width="700"
            header="File settings"
            save={this.state.activeBlock ? this.saveBlock : false}
            closePopup={() => {
              this.setState({ editID: false });
            }}
            close={() => {
              this.setState({
                editID: false,
              });
            }}
            parentID="fileModal-Setting"
          >
            <div className="modalScrollContainerSecondary">
              <div className="modalContentWrapper">
                <label>
                  File Label <small> (For Meta Data and Aria Labels)</small>
                </label>
                <input
                  onChange={this.addFileLabel}
                  defaultValue={this.props.label}
                  placeholder="Add File Label"
                  className="textLabelInput"
                  type="text"
                />

                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="choosedFile top-10"
                >
                  {this.props.files
                    ? this.props.files.map((item, index) => {
                        return (
                          <div
                            className={
                              this.props.thumbID == item.file_id
                                ? "active"
                                : " "
                            }
                            key={index}
                          >
                            <p className="imageWrap">
                              <img
                                onClick={() => {
                                  this.chooseThumb(item);
                                }}
                                onError={(e) => {
                                  e.target.src = noImage;
                                }}
                                src={item.file_thumb}
                              />
                            </p>
                          </div>
                        );
                      })
                    : ""}
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                    }}
                  >
                    {" "}
                    <button
                      className="select-various-content-button"
                      onClick={() => {
                        this.setState({
                          id: this.props.ID,
                          editID: null,
                        });
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        width="15"
                        height="20"
                        viewBox="0 0 21.5 26.5"
                      >
                        <g
                          id="file_icon"
                          transform="translate(0 0)"
                          clipPath="url(#clip-path)"
                        >
                          <path
                            id="Path_383"
                            data-name="Path 383"
                            d="M16.5,2H6.5A2.5,2.5,0,0,0,4,4.5v20A2.507,2.507,0,0,0,6.5,27h15A2.5,2.5,0,0,0,24,24.5V9.5Z"
                            transform="translate(-3.25 -1.25)"
                            fill="none"
                            stroke="#708fab"
                            strokeLinecap="square"
                            strokeWidth="1.5"
                          />
                          <path
                            id="Path_384"
                            data-name="Path 384"
                            d="M15.443,3V9.2h6.2m-3.722,6.2H8m9.924,4.962H8m2.481-9.924H8"
                            transform="translate(-1.896 -1.25)"
                            fill="none"
                            stroke="#708fab"
                            strokeLinecap="square"
                            strokeWidth="1.5"
                          />
                        </g>
                      </svg>
                      {this.props.files.length > 1 ? "Change" : "Add"} Files
                    </button>
                    <button
                      className="select-various-content-button"
                      onClick={this.deleteFile}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                      >
                        <g id="delete" transform="translate(34.5 5.5)">
                          <g id="trash" transform="translate(-32.5 -3.5)">
                            <path
                              id="Path_363"
                              data-name="Path 363"
                              d="M3,6H16.539"
                              transform="translate(0 -0.991)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.3"
                            />
                            <path
                              id="Path_364"
                              data-name="Path 364"
                              d="M15.53,5.009v10.53a1.5,1.5,0,0,1-1.5,1.5H6.5a1.5,1.5,0,0,1-1.5-1.5V5.009m2.257,0V3.5A1.5,1.5,0,0,1,8.761,2H11.77a1.5,1.5,0,0,1,1.5,1.5v1.5"
                              transform="translate(-0.496)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.3"
                            />
                            <line
                              id="Line_64"
                              data-name="Line 64"
                              y2="4.513"
                              transform="translate(8.265 8.77)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.3"
                            />
                            <line
                              id="Line_65"
                              data-name="Line 65"
                              y2="4.513"
                              transform="translate(11.274 8.77)"
                              fill="none"
                              stroke="#0c3254"
                              strokeLinecap="square"
                              strokeWidth="1.3"
                            />
                          </g>
                        </g>
                      </svg>
                      Remove Files
                    </button>
                  </div>
                </div>
                <div></div>
              </div>
              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Width</div>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  width: "100%",
                  padding: "20px",
                }}
              >
                <UnitSelector
                  value={
                    this.props.fileWidthUnit ? this.props.fileWidthUnit : "px"
                  }
                  onChange={(e) => {
                    this.unitWidthValueChange(e, "fileWidthUnit");
                  }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "row" }}
                className="modalContentWrapper"
              >
                <Col sm="2" className="widthSlideRange file-range">
                  <label>
                    <small>Width 100%</small>
                  </label>
                  <input
                    key={Math.random()}
                    className="checkMark"
                    type="checkbox"
                    id="widthPercentage"
                    name="width"
                    value="percentage"
                    onChange={(e) => {
                      this.widthToggle(e, "maxWidth");
                    }}
                    checked={this.props.width == "" ? true : false}
                  />
                  <label htmlFor="widthPercentage"></label>
                </Col>
                <Col sm="8">
                  <div className="widthSlideRange file-range">
                    {this.props.width != "" && (
                      <Fragment>
                        <label>
                          File Width <small>(Set range for file width)</small>
                        </label>
                        <div className="rangeWidthSlider">
                          <RangeInputSlider
                            onChangeHandler={(widthVal) => {
                              this.rangeWidthSlider(widthVal);
                            }}
                            widthValue={this.props.width}
                            maxWidthRange={
                              this.props.fileWidthUnit == "%"
                                ? 100
                                : this.state.maxWidthRange
                            }
                          />
                        </div>
                      </Fragment>
                    )}
                  </div>
                </Col>
                {this.props.width != "" && (
                  <div
                    style={{ marginTop: "18px" }}
                    className="widthRangeLabel"
                  >
                    <input
                      onChange={(e) => {
                        UTILS.ValidateIfValueNumber(e.target.value) &&
                        (this.props.fileWidthUnit == "%"
                          ? e.target.value < 100
                          : e.target.value)
                          ? this.counterChange(e, "maxWidth")
                          : null;
                      }}
                      value={this.props.width}
                      type="text"
                    />
                  </div>
                )}
              </div>

              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Opacity</div>
              </div>
              <Col sm="12" className="fileOpacity modalContentWrapper">
                <label>
                  Opacity <small>(Set range for file opacity)</small>
                </label>
                <input
                  type="range"
                  max="1.0"
                  min="0"
                  step="0.01"
                  value={this.props.opacity}
                  onChange={(e) => {
                    this.changeFileOpacity(e, "opacity");
                  }}
                />
              </Col>
              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Alignment</div>
              </div>
              <Col sm="6" className="modalContentWrapper">
               
                <div className="modalSetting" style={{ float: "left" }}>
            

                </div>
                <div style={{ width: '33%' }}>
                  <label>File Align</label>
                  <select
                    value={this.props.float}
                    onChange={this.changeFileAlign}
                  >
                    <option value="left">Left</option>
                    <option value="none">Center</option>
                    <option value="right">Right</option>
                  </select>
                </div>
              </Col>
              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Border</div>
              </div>
              <div className="modalContentWrapper">
                <Counter
                  label="Border Radius"
                  minusClick={() =>
                    this.counterMinus(this.props.radius, "borderRadius")
                  }
                  plusClick={() =>
                    this.counterPlus(this.props.radius, "borderRadius")
                  }
                  valueContent={this.props.radius}
                  disabled={false}
                  onChange={(e) => {
                    this.counterChange(e, "borderRadius");
                  }}
                />
              </div>
              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Margin</div>
              </div>
              <div
                className="heading-row"
                style={{ justifyContent: "flex-end" }}
              >
                <UnitSelector
                  value={
                    this.props.fileMarginUnit ? this.props.fileMarginUnit : "px"
                  }
                  onChange={(e) => {
                    this.unitValueChange(e, "fileMarginUnit");
                  }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "row" }}
                className="modalContentWrapper"
              >
                <Col sm="3" className="top-15">
                  <Counter
                    label="Margin Top"
                    small={
                      this.props.fileMarginUnit === "%" ? "percent" : "pixel"
                    }
                    minusClick={() =>
                      this.counterMinus(this.props.marginTop, "marginTop")
                    }
                    plusClick={() =>
                      this.counterPlus(this.props.marginTop, "marginTop")
                    }
                    valueContent={this.props.marginTop}
                    disabled={false}
                    onChange={(e) => {
                      this.counterChange(e, "marginTop");
                    }}
                  />
                </Col>
                <Col sm="4" className="top-15">
                  <Counter
                    label="Margin Bottom"
                    small={
                      this.props.fileMarginUnit === "%" ? "percent" : "pixel"
                    }
                    minusClick={() =>
                      this.counterMinus(this.props.marginBottom, "marginBottom")
                    }
                    plusClick={() =>
                      this.counterPlus(this.props.marginBottom, "marginBottom")
                    }
                    valueContent={this.props.marginBottom}
                    disabled={false}
                    onChange={(e) => {
                      this.counterChange(e, "marginBottom");
                    }}
                  />
                </Col>
              </div>
            </div>
          </Popup>
        ) : null}
        {this.state.id === this.props.ID ? (
          <Library
            initP="0"
            ID={this.props.ID}
            thumbID={this.props.thumbID}
            userID={this.props.userID}
            sessionID={this.props.sessionID}
            fileTab={true}
            toggleUploadPopup={() => {
              this.setState({ id: null });
            }}
            pushFiles={this.pushFiles}
            selectingContent={true}
            opacity={this.props.opacity}
            radius={this.props.radius}
            float={this.props.float}
            files={this.props.files}
          />
        ) : null}
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(File);
